export default __webpack_public_path__ + "static/media/Breeches of the Oxmal.05ce3f3f.jpg";